import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { InputNumber } from 'primereact/inputnumber';
import reportsServices from "../../services/reports/reportservice";

interface DataTableProps {
  data: any[];
}

const POSTargetMappingListDataTable: React.FC<DataTableProps> = ({ data }) => {
  const toast = useRef<Toast>(null);
  const [orderDataList, setOrderDataList] = useState<any>([]);
  const [totalTarget, setTotalTarget] = useState<number>(0);

  // Calculate totals whenever data changes
  useEffect(() => {
    setOrderDataList(data);

    const total = data?.reduce((sum, row) => {
      return sum + (parseFloat(row.target) || 0);
    }, 0);

    setTotalTarget(total);
  }, [data]);

  const textEditor = (options: any) => {
    return (
      <InputNumber
        value={options.value}
        onChange={(e: any) => options.editorCallback(e.value, options.index)}
        mode="currency"
        currency="INR"
        locale="en-US"
      />
    );
  };

  const onRowEditComplete = (e: any) => {
    let _products = [...orderDataList];
    let { newData, index } = e;
    _products[index] = newData;

    reportsServices.updatePOSTargetMapping(newData).then((response: any) => {
      if (response.isSuccess) {
        setOrderDataList(_products);

        // Update total after edit
        const newTotal = _products.reduce((sum, row) => {
          return sum + (parseFloat(row.target) || 0);
        }, 0);
        setTotalTarget(newTotal);

        toast.current?.show({
          severity: 'success',
          summary: 'Success',
          detail: response.message,
          life: 3000
        });
      }
    });
  };

  const formatCurrency = (value: any) => {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'INR' });
  };

  const balanceBodyTemplate = (rowData: any) => {
    return formatCurrency(rowData.target);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="col-12 card border-noround p-2">
        {orderDataList && (
          <DataTable
            editMode="row"
            onRowEditComplete={onRowEditComplete}
            value={orderDataList}
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            stripedRows
            showGridlines
            emptyMessage="No order found."
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          >
            <Column
              field="posName"
              header="Name"
              style={{ width: '20%' }}
              footer="Total:"
            ></Column>

            <Column
              field="target"
              header="Target"
              body={balanceBodyTemplate}
              editor={(options) => textEditor(options)}
              style={{ width: '20%' }}
              footer={formatCurrency(totalTarget)}
            ></Column>

            <Column
              rowEditor={true}
              header="Action"
              headerStyle={{ width: '10%', minWidth: '8rem' }}
              bodyStyle={{ textAlign: 'center' }}
            ></Column>
          </DataTable>
        )}
      </div>
    </>
  );
};

export default POSTargetMappingListDataTable;
